export default "__VITE_ASSET__4CEjQ3jw__"